import Select from '@blocks/Select'
import { Filter } from '@components/modules/Table/types'
import React from 'react'
import { PAYMENT } from '../config/constants'

export default function PaidStatusFilter({ table }: GetProps<Filter<Interfaces.Customer>>) {
    return (
        <Select id="paid" name="paid" background="white" label="Status" options={[
            { value: "paid", label: "Paid" }, { value: "not_paid", label: "Not Paid" }
        ]} isClearable onChange={(option?: Interfaces.Options<"paid" | "not_paid">[0]) => {
            if (!option) 
                table.setFilter("paid", undefined)
            
            if (option!.value === "paid")
                table.setFilter("paid", true)

            if (option!.value === "not_paid") 
                table.setFilter("paid", false)
        }} />
    )
}
